import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import translations from '../locales.json'
import { TranslationProvider } from '../../shared/TranslationProvider'
import { BrowserRouter } from 'react-router'
import { IndustryResourcesProvider } from './IndustryResourcesProvider'
import ToolBar from './ToolBar'
import SearchResults from './SearchResults'

const queryClient = new QueryClient()

export default function IndustryResourcesPage({ locale, ...props }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TranslationProvider
        locale={locale}
        translations={translations}
        scope="javascript.components.ResearchLearning.IndustryResourcesPage"
      >
        <BrowserRouter>
          <IndustryResourcesProvider {...props}>
            <div className="flex flex-col border-l border-alto-200 pl-2 font-roboto">
              <div className="my-10 ml-4 mr-6 flex flex-col gap-8">
                <ToolBar />
                <SearchResults />
              </div>
            </div>
          </IndustryResourcesProvider>
        </BrowserRouter>
      </TranslationProvider>
    </QueryClientProvider>
  )
}
